// extracted by mini-css-extract-plugin
export default {"board-pop":"index_board-pop__dBfOy","curFile":"index_curFile__EUAfH","curFileName":"index_curFileName__270R3","fileName":"index_fileName__1rQYo"};